export const environment = {
  production: false,
  apiUrl: 'https://api.irisdevs.com/api',
  usuario: "kiosko@test.com",
  electron: false,
  capacitor: false,
  mostrarTeclado: false,
  password: "test",
  recaptchaSiteKey: "6Lf3_mktAAAAAIRB1cP9Wzzf5MrrUEjzBBzp4tKH"
};
